export class PaginatorConfig{
    pageNum = 0;
    pageSize = 20;
    filterColumn = 'endDate';
    filterDirection = 'asc';


    public getPageNum():number{
        return this.pageNum;
    }

    public getPageSize():number{
        return this.pageSize;
    }

    public getFilterColumn():string{
        return this.filterColumn;
    }

    public setFilterColumn(val){
        this.filterColumn = val;
    }

    public setFilterDirection(val){
        this.filterDirection = val;
    }

    public getFilterDirection():string{
        return this.filterDirection;
    }

    public setPageNum(pageN:number){
        this.pageNum = pageN;
    }

    public setPageSize(pageS:number){
        this.pageSize = pageS;
    }


}